import getStore from '../store/store';
import { getAccountKeyForMailboxInfo } from 'owa-client-types';
import { logPrioritizeTelemetryEvent } from 'owa-copilot-telemetry/lib/prioritizeTelemetryLogger';
import type { MailboxInfo } from 'owa-client-types';
import { getItem, setItem } from 'owa-local-storage';
import { isGlobalFeatureEnabled } from 'owa-feature-flags';

let hasLogged = false;
function logUsageOncePerSession(mailboxInfo: MailboxInfo, data: Record<string, any>): void {
    if (!hasLogged) {
        logPrioritizeTelemetryEvent('OpenInbox', mailboxInfo, data);
        hasLogged = true;
    }
}

const EXPERIMENTAL_SETTING_KEY = 'mail_copilot_prioritize_experimental_setting';

export default function savePrioritizeSettings(mailboxInfo: MailboxInfo, response: any): void {
    const accountKey = getAccountKeyForMailboxInfo(mailboxInfo);
    const inboxResponse = response.inboxPrioritizationPreferences;

    const prioritizeStoreMap = getStore().copilotPrioritizeSettingsStoreMap;
    const prioritizeStore = prioritizeStoreMap.get(accountKey);

    if (inboxResponse.version === 1) {
        // replacePreviewWithMicroSummary isn't present in the response for version 1
        // so we need to set it to true (which is the assumed default)
        inboxResponse.replacePreviewWithMicroSummary = true;
    }

    if (
        inboxResponse.prioritizationEnabled &&
        ((inboxResponse.moreImportantRules?.length ?? 0 > 0) ||
            (inboxResponse.lessImportantRules?.length ?? 0) > 0 ||
            (inboxResponse.miscellaneousRules?.length ?? 0) > 0)
    ) {
        logUsageOncePerSession(mailboxInfo, {
            PrioritizationEnabled: inboxResponse.prioritizationEnabled,
            ApplyLowPriorityLabel: inboxResponse.applyLowPriorityLabel,
            MoreImportantRulesCount: inboxResponse.moreImportantRules?.length ?? 0,
            LessImportantRulesCount: inboxResponse.lessImportantRules?.length ?? 0,
            MiscellaneousRulesCount: inboxResponse.miscellaneousRules?.length ?? 0,
            ExperimentalSetting: isGlobalFeatureEnabled('tri-prioritize-on-demand')
                ? inboxResponse.experimentalSetting ?? 'true'
                : 'null', // Log the experimental setting only if the feature is enabled. This is to understand the distribution of the setting in the population when the feature is enabled.
        });
    }

    // experimentalSetting doesn't exist on the object we get when hydrating settings
    // from startupdata. In this case, we'll check to see if the user had the Priority
    // Nudge enabled in the previous session and set it to true by default.
    if (inboxResponse.experimentalSetting === undefined) {
        const experimentalSetting = getItem(window, EXPERIMENTAL_SETTING_KEY);
        inboxResponse.experimentalSetting = experimentalSetting ?? null;
    }

    setItem(window, EXPERIMENTAL_SETTING_KEY, inboxResponse.experimentalSetting);

    if (prioritizeStore) {
        prioritizeStore.settings = inboxResponse;
        prioritizeStore.isInitialized = true;
        prioritizeStore.version = prioritizeStore.version + 1;
    } else {
        prioritizeStoreMap.set(getAccountKeyForMailboxInfo(mailboxInfo), {
            settings: inboxResponse,
            isInitialized: true,
            version: 1,
        });
    }
}
